export default __webpack_public_path__ + "static/media/select-arrow.1f30b652.svg";